export default {
  'address-form:first-name-label': 'Voornaam',
  'address-form:last-name-label': 'Achternaam',
  'address-form:street-label': 'Straat + nr.',
  'address-form:additional-details-label': 'Adrestoevoeging / Bedrijf / Co / Postnummer',
  'address-form:zip-label': 'Postcode',
  'address-form:town-label': 'Plaats',
  'address-form:country-label': 'Land',
  'address-form:phone-label': 'Telefoonnummer',
};
